import React from 'react';

export default function Footer(){
    return(
        <footer className="footer">
        <div className="container">
            <span>Made with <i className="fas fa-heart"></i> and React JS</span>
        </div>
    </footer>
    )
}